<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f"><a id="page_6"></a><strong>CONTENTS</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/introduction#introduction">introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch1#ch1">a.m.</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch2#ch2" title="Link target outside of Sample">p.m.</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch3#ch3" title="Link target outside of Sample">weekend</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appendix#appendix" title="Link target outside of Sample">appendix</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appendix#app-1" title="Link target outside of Sample"><img alt="images" src="images/arrow.jpg"/> special techniques</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appendix#app-2" title="Link target outside of Sample"><img alt="images" src="images/arrow.jpg"/> abbreviations</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appendix#app-3" title="Link target outside of Sample"><img alt="images" src="images/arrow.jpg"/> yarn sources</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/appendix#app-4" title="Link target outside of Sample"><img alt="images" src="images/arrow.jpg"/> acknowledgments</span></p>
<p class="pagebreak"> </p>
<p class="imagef"><img alt="image" src="images/f0006-01.jpg"/><a id="page_7"></a></p>
<p class="imagef"><a id="page_8"></a><img alt="image" src="images/f0008-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?ea62b7d8